"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var es6_promise_1 = require("es6-promise");
var go = require("gojs");
var GoCloudStorage = (function () {
    function GoCloudStorage(managedDiagrams, defaultModel, clientId, iconsRelativeDirectory) {
        if (managedDiagrams instanceof go.Diagram)
            managedDiagrams = [managedDiagrams];
        this._managedDiagrams = managedDiagrams;
        this._currentDiagramFile = { name: null, id: null, path: null };
        this._isAutoSaving = true;
        if (clientId)
            this._clientId = clientId;
        else
            clientId = null;
        if (defaultModel) {
            var firstChar = defaultModel.trim().charAt(0);
            if (defaultModel && firstChar === '{')
                this._defaultModel = defaultModel;
            if (firstChar !== '{' && !iconsRelativeDirectory)
                this._iconsRelativeDirectory = defaultModel;
            else
                this._iconsRelativeDirectory = (!!iconsRelativeDirectory) ? iconsRelativeDirectory : '../goCloudStorageIcons/';
        }
        else {
            this._defaultModel = null;
        }
        var menu = document.createElement('div');
        menu.className = 'goCustomFilepicker';
        menu.style.visibility = 'hidden';
        document.getElementsByTagName('body')[0].appendChild(menu);
        this._ui = menu;
        this._deferredPromise = { promise: this.makeDeferredPromise() };
        function addAutoSave(d) {
            d.addModelChangedListener(function (e) {
                if (e.isTransactionFinished && storage.isAutoSaving && e.oldValue !== '') {
                    if (storage.currentDiagramFile.name) {
                        storage.save();
                    }
                }
            });
        }
        var d = this.managedDiagrams;
        var storage = this;
        if (d instanceof go.Diagram) {
            addAutoSave(d);
        }
        else {
            for (var i = 0; i < d.length; i++) {
                addAutoSave(d[i]);
            }
        }
    }
    Object.defineProperty(GoCloudStorage.prototype, "managedDiagrams", {
        get: function () { return this._managedDiagrams; },
        set: function (value) { this._managedDiagrams = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GoCloudStorage.prototype, "defaultModel", {
        get: function () { return this._defaultModel; },
        set: function (value) { this._defaultModel = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GoCloudStorage.prototype, "iconsRelativeDirectory", {
        get: function () { return this._iconsRelativeDirectory; },
        set: function (value) { this._iconsRelativeDirectory = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GoCloudStorage.prototype, "clientId", {
        get: function () { return this._clientId; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GoCloudStorage.prototype, "currentDiagramFile", {
        get: function () { return this._currentDiagramFile; },
        set: function (value) { this._currentDiagramFile = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GoCloudStorage.prototype, "isAutoSaving", {
        get: function () { return this._isAutoSaving; },
        set: function (value) { this._isAutoSaving = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GoCloudStorage.prototype, "serviceName", {
        get: function () { return this._serviceName; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GoCloudStorage.prototype, "className", {
        get: function () { return this._className; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GoCloudStorage.prototype, "ui", {
        get: function () { return this._ui; },
        enumerable: true,
        configurable: true
    });
    GoCloudStorage.prototype.authorize = function (refreshToken) {
        if (refreshToken === void 0) { refreshToken = false; }
        return new es6_promise_1.Promise(function (resolve, reject) {
            reject('authorize not implemented');
        });
    };
    GoCloudStorage.prototype.makeDeferredPromise = function () {
        var res;
        var rej;
        var promise = new es6_promise_1.Promise(function (resolve, reject) {
            res = resolve;
            rej = reject;
        });
        promise.resolve = res;
        promise.reject = rej;
        return promise;
    };
    GoCloudStorage.prototype.getUserInfo = function () {
        return new es6_promise_1.Promise(function (resolve, reject) {
            reject('getUserInfo not implemented');
        });
    };
    GoCloudStorage.prototype.hideUI = function (isActionCanceled) {
        if (isActionCanceled === void 0) { isActionCanceled = false; }
        var storage = this;
        storage.ui.style.visibility = 'hidden';
        if (isActionCanceled) {
            var action = document.getElementById('actionButton').innerHTML;
            storage._deferredPromise.promise.resolve(action + ' canceled by user');
            storage._deferredPromise.promise = storage.makeDeferredPromise();
        }
    };
    GoCloudStorage.prototype.checkFileExists = function (path) {
        return new es6_promise_1.Promise(function (resolve, reject) {
            reject('checkFileExists not implemented');
        });
    };
    GoCloudStorage.prototype.getFile = function (path) {
        return new es6_promise_1.Promise(function (resolve, reject) {
            throw Error('getFile not implemented');
        });
    };
    GoCloudStorage.prototype.showUI = function (action) {
        return new es6_promise_1.Promise(function (resolve, reject) {
            throw Error('showUI not implemented');
        });
    };
    GoCloudStorage.prototype.create = function (path, saveBefore) {
        if (saveBefore === void 0) { saveBefore = false; }
        var storage = this;
        function makeNewDiagram(d) {
            if (storage.defaultModel)
                d.model = go.Model.fromJson(JSON.parse(storage.defaultModel));
            else
                d.model = new go.GraphLinksModel();
        }
        return new es6_promise_1.Promise(function (resolve, reject) {
            if (saveBefore) {
                storage.promptUserToSaveBeforeNew().then(function (resp) {
                    if (resp) {
                        storage.saveWithUI().then(function (diagramFile) {
                            storage.currentDiagramFile = { name: null, id: null, path: null };
                            if (storage.managedDiagrams instanceof go.Diagram) {
                                makeNewDiagram(storage.managedDiagrams);
                            }
                            else {
                                for (var i = 0; i < storage.managedDiagrams.length; i++) {
                                    makeNewDiagram(storage.managedDiagrams[i]);
                                }
                            }
                            if (storage.isAutoSaving) {
                                if (path) {
                                    resolve(storage.save(path));
                                }
                                else
                                    resolve(storage.saveWithUI());
                            }
                            else
                                resolve('New diagram created.');
                        });
                    }
                    else {
                        storage.currentDiagramFile = { name: null, id: null, path: null };
                        if (storage.managedDiagrams instanceof go.Diagram) {
                            makeNewDiagram(storage.managedDiagrams);
                        }
                        else {
                            for (var i = 0; i < storage.managedDiagrams.length; i++) {
                                makeNewDiagram(storage.managedDiagrams[i]);
                            }
                        }
                        if (storage.isAutoSaving) {
                            if (path) {
                                resolve(storage.save(path));
                            }
                            else
                                resolve(storage.saveWithUI());
                        }
                        else
                            resolve('New diagram created.');
                    }
                });
            }
            if (!saveBefore) {
                storage.currentDiagramFile = { name: null, id: null, path: null };
                if (storage.managedDiagrams instanceof go.Diagram) {
                    makeNewDiagram(storage.managedDiagrams);
                }
                else {
                    for (var i = 0; i < storage.managedDiagrams.length; i++) {
                        makeNewDiagram(storage.managedDiagrams[i]);
                    }
                }
                if (storage.isAutoSaving) {
                    if (path) {
                        resolve(storage.save(path));
                    }
                    else
                        resolve(storage.saveWithUI());
                }
                else
                    resolve('New diagram created.');
            }
        });
    };
    GoCloudStorage.prototype.promptUserToSaveBeforeNew = function () {
        return new es6_promise_1.Promise(function (resolve, reject) {
            var d = document.getElementById('gcs-save-before-new');
            if (d) {
                document.body.removeChild(d);
            }
            var div = document.createElement('div');
            div.id = 'gcs-save-before-new';
            var p = document.createElement('p');
            p.innerText = 'Save current diagram(s) before creating a new file?';
            var yb = document.createElement('button');
            yb.innerText = 'Yes';
            var nb = document.createElement('button');
            nb.innerText = 'No';
            yb.onclick = function () {
                document.body.removeChild(div);
                resolve(true);
            };
            nb.onclick = function () {
                document.body.removeChild(div);
                resolve(false);
            };
            nb.style['float'] = 'right';
            div.style['font-family'] = 'Arial, Helvetica, sans-serif';
            div.style['width'] = '400px';
            div.style['top'] = '25%';
            div.style['left'] = '40%';
            div.style['position'] = 'absolute';
            div.style['border'] = '1px solid black';
            div.style['padding'] = '10px';
            div.style['box-shadow'] = '10px 10px 5px #888888';
            div.style['background'] = 'white';
            div.style['z-index'] = '100';
            div.appendChild(p);
            div.appendChild(yb);
            div.appendChild(nb);
            document.body.appendChild(div);
        });
    };
    GoCloudStorage.prototype.makeSaveFile = function () {
        var item = '{\n';
        var storage = this;
        if (storage.managedDiagrams.length === 0)
            return;
        for (var i = 0; i < storage.managedDiagrams.length; i++) {
            var diagram = storage.managedDiagrams[i];
            var div = diagram.div.id;
            var _model = diagram.model.toJson();
            item += '"' + div + '"' + ': ' + diagram.model.toJson();
            if (i + 1 !== storage.managedDiagrams.length)
                item += ',\n';
        }
        item += '\n}';
        return item;
    };
    GoCloudStorage.prototype.loadFromFileContents = function (fileContents) {
        var models = JSON.parse(fileContents);
        for (var divId in models) {
            var model = models[divId];
            var div = document.getElementById(divId);
            var diagram = go.Diagram.fromDiv(div);
            if (diagram) {
                diagram.model = go.Model.fromJson(JSON.stringify(model));
            }
            else {
                throw Error('No Diagram on page is associated with a div with id ' + divId);
            }
        }
    };
    GoCloudStorage.prototype.saveWithUI = function () {
        return new es6_promise_1.Promise(function (resolve, reject) {
            reject('saveWithUI not implemented');
        });
    };
    GoCloudStorage.prototype.save = function (path) {
        return new es6_promise_1.Promise(function (resolve, reject) {
            reject('save not implemented');
        });
    };
    GoCloudStorage.prototype.load = function (path) {
        return new es6_promise_1.Promise(function (resolve, reject) {
            reject('load not implemented');
        });
    };
    GoCloudStorage.prototype.loadWithUI = function () {
        return new es6_promise_1.Promise(function (resolve, reject) {
            reject('loadWithUI not implemented');
        });
    };
    GoCloudStorage.prototype.remove = function (path) {
        return new es6_promise_1.Promise(function (resolve, reject) {
            reject('remove not implemented');
        });
    };
    GoCloudStorage.prototype.removeWithUI = function () {
        return new es6_promise_1.Promise(function (resolve, reject) {
            reject('removeWithUI not implemented');
        });
    };
    return GoCloudStorage;
}());
exports.GoCloudStorage = GoCloudStorage;
